import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import PublicPage from "./PublicPage";
import Oauth2RedirectPage from "../auth/types/oauth2/Oauth2RedirectPage";

const PublicRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path="/authorization/oauth2/redirect" element={<Oauth2RedirectPage />} />
        <Route path="*" element={<PublicPage />} />
      </Routes>
    </Router>
  );
};

export default PublicRouter;
